import { render, staticRenderFns } from "./OrticTextarea.vue?vue&type=template&id=90c4d6a4"
import script from "./OrticTextarea.vue?vue&type=script&lang=js"
export * from "./OrticTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports